var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":_vm.currentStepFlag,"disabled":_vm.disabledFlag},on:{"click":_vm.navigate}},[_c('strong',[_vm._v(_vm._s(_vm.stepNumber))]),_c('br'),(_vm.windowWidth > 850 || _vm.windowWidth < 500)?_c('div',[_vm._v(" "+_vm._s(_vm.stepName)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }